import { IComposableDashboardCollectionsContext } from 'wisestep-api';

import { useComposableDashboardCollectionsContext } from './useComposableDashboardCollectionsContext';

const usePromptText = (entityName?: string) => {
  const { selectedDashboardCollection } =
    useComposableDashboardCollectionsContext() as Required<IComposableDashboardCollectionsContext>;
  const pinPromptText = `Are you sure want to Pin "${
    entityName ?? selectedDashboardCollection?.name ?? ''
  }" to Home page?`;
  const unPinPromptText = `Are you sure want to unpin "${
    entityName ?? selectedDashboardCollection?.name ?? ''
  }" from Home page?`;

  const assignToClientsPromptText = `Are you sure want to Assign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" to Clients?`;
  const unAssignToClientsPromptText = `Are you sure want to Unassign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" from Clients?`;

  const assignToClientSpocPromptText = `Are you sure want to Assign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" to Client Spocs?`;
  const unAssignToClientSpocPromptText = `Are you sure want to Unassign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" from Client Spocs?`;

  const assignToAccountManagerOUPromptText = `Are you sure want to Assign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" to Account Units?`;
  const unAssignToAccountManagerOUPromptText = `Are you sure want to Unassign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" from Account Units?`;

  const assignToTeamsOUPromptText = `Are you sure want to Assign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" to Delivery Units?`;
  const unAssignToTeamsOUPromptText = `Are you sure want to Unassign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" from Delivery Units?`;

  const assignToTeamsPromptText = `Are you sure want to Assign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" to Teams?`;
  const unAssignToTeamsPromptText = `Are you sure want to Unassign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" from Teams?`;

  const assignToAccountManagersPromptText = `Are you sure want to Assign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" to Account Managers?`;
  const unAssignToAccountManagersPromptText = `Are you sure want to Unassign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" from Account Managers?`;

  const assignToBusinessDefinitionPromptText = `Are you sure want to Assign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" to Business Units?`;
  const unAssignToBusinessDefinitionPromptText = `Are you sure want to Unassign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" from Business Units?`;

  const assignToClientUnitPromptText = `Are you sure want to Assign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" to Client Units?`;
  const unAssignToClientUnitPromptText = `Are you sure want to Unassign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" from Client Units?`;

  const assignToClientContactUnitPromptText = `Are you sure want to Assign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" to Client Contact Units?`;
  const unAssignToClientContactUnitPromptText = `Are you sure want to Unassign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" from Client Contact Units?`;

  const assignToUsersPromptText = `Are you sure want to Assign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" to Users?`;
  const unAssignToUsersPromptText = `Are you sure want to Unassign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" from Users?`;

  const assignToJobsPromptText = `Are you sure want to Assign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" to Jobs?`;

  const unAssignToJobsPromptText = `Are you sure want to Unassign Dashboard Collection "${
    selectedDashboardCollection?.name ?? ''
  }" from Jobs?`;

  return {
    pinPromptText,
    unPinPromptText,
    assignToClientsPromptText,
    unAssignToClientsPromptText,
    unAssignToClientSpocPromptText,
    assignToAccountManagerOUPromptText,
    unAssignToAccountManagerOUPromptText,
    assignToClientSpocPromptText,
    assignToTeamsOUPromptText,
    unAssignToTeamsOUPromptText,
    assignToTeamsPromptText,
    unAssignToTeamsPromptText,
    assignToAccountManagersPromptText,
    unAssignToAccountManagersPromptText,
    assignToBusinessDefinitionPromptText,
    unAssignToBusinessDefinitionPromptText,
    assignToClientUnitPromptText,
    unAssignToClientUnitPromptText,
    assignToClientContactUnitPromptText,
    unAssignToClientContactUnitPromptText,
    assignToUsersPromptText,
    unAssignToUsersPromptText,
    assignToJobsPromptText,
    unAssignToJobsPromptText,
  };
};

export default usePromptText;
